import React from "react";
import PropTypes from "prop-types";
import Modal from "@paprika/modal";
import Button from "@paprika/button";
import L10n from "@paprika/l10n";
import i18n from "@viz-ui/i18n/i18n";

const InvalidVizModal = props => {
  const { isOpen, onClose } = props;

  return (
    <L10n locale={i18n.locale || "en"}>
      <Modal isOpen={isOpen} onClose={onClose} zIndex={210} className="invalid-viz-modal">
        <Modal.Overlay />
        <Modal.Header>{i18n.t("_SaveViz.Invalid.Visualization.Modal.Title_")}</Modal.Header>
        <Modal.Content>
          <p className="invalid-viz-modal__message">{i18n.t("_SaveViz.Invalid.Visualization.Message_")}</p>
        </Modal.Content>
        <Modal.Footer>
          <Button onClick={onClose} kind="primary" id="invalid-viz-warning-modal-btn">
            {i18n.t("_Button.OK.Label_")}
          </Button>
        </Modal.Footer>
      </Modal>
    </L10n>
  );
};

InvalidVizModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};

InvalidVizModal.defaultProps = {
  isOpen: false,
};

export default InvalidVizModal;
